import React from 'react'
import PropTypes from 'prop-types'
import {Nav, Navbar, NavItem, NavDropdown, MenuItem} from 'react-bootstrap'
import {LinkContainer} from 'react-router-bootstrap'
import logo from '../images/header-canfax.png'
import {connect} from 'react-redux'

@connect((state) => {
  return {
    isLoggedIn: state.app.isLoggedIn,
  }
})
class Header extends React.Component {
  render() {
    return (
      <Navigation
        isLoggedIn={this.props.isLoggedIn}
        handleLogOut={this.props.handleLogOut}
        pages={this.props.pages}
      />
    )
  }
}

Header.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  handleLogOut: PropTypes.func.isRequired,
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.number.isRequired,
      path: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      subItems: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.number.isRequired,
          path: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
        }),
      ),
    }),
  ).isRequired,
}

export default Header

class Navigation extends React.Component {
  static propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
    handleLogOut: PropTypes.func.isRequired,
    pages: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.number.isRequired,
        path: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        subItems: PropTypes.arrayOf(
          PropTypes.shape({
            key: PropTypes.number.isRequired,
            path: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
          }),
        ),
      }),
    ).isRequired,
  }

  render() {
    let leftNavPages = []
    let rightNavPages = []
    this.props.pages.forEach((element, index) => {
      let navItem
      if (element.subItems) {
        let subNavPages = element.subItems.map((subElement, subIndex) => {
          return (
            <LinkContainer key={subElement.key} to={subElement.path}>
              <MenuItem eventKey={subElement.key}>{subElement.title}</MenuItem>
            </LinkContainer>
          )
        })
        navItem = (
          <NavDropdown
            key={element.key}
            eventKey={element.key}
            title={
              element.icon ? (
                <div style={{display: 'inline'}}>
                  <i className={element.icon} /> {element.title}
                </div>
              ) : (
                element.title
              )
            }
            id="basic-nav-dropdown"
          >
            {subNavPages}
          </NavDropdown>
        )
      } else {
        navItem = (
          <LinkContainer key={element.key} to={element.path}>
            <NavItem eventKey={element.key}>
              {element.icon && <i className={element.icon} />}&nbsp;
              {element.title}
            </NavItem>
          </LinkContainer>
        )
      }

      if (element.float && element.float === 'right') {
        rightNavPages.push(navItem)
      } else {
        leftNavPages.push(navItem)
      }
    })

    // if (this.props.isLoggedIn) {
    //   leftNavPages.push(
    //     <NavItem
    //       key={this.props.pages.length + 1}
    //       eventKey={this.props.pages.length + 1}
    //       onClick={this.props.handleLogOut}
    //     >
    //       Logout
    //     </NavItem>,
    //   )
    // } else {
    //   leftNavPages.push(
    //     <LinkContainer key={this.props.pages.length + 1} to="/login">
    //       <NavItem eventKey={this.props.pages.length + 1}>
    //         <i className="fa fa-sign-in-alt" />
    //         &nbsp;Login
    //       </NavItem>
    //     </LinkContainer>,
    //   )
    // }

    return (
      <Navbar fixedTop={true} fluid={true} collapseOnSelect={true}>
        <Navbar.Header>
          <Navbar.Toggle />
          <Navbar.Brand>
            <a href="/" className="header_brand">
              <img src={logo} alt="CanFax Logo" />
            </a>
          </Navbar.Brand>
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>{leftNavPages}</Nav>
          <Nav pullRight>{rightNavPages}</Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/header.js